function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Fragment } from 'react';
import { getTheme } from '@uifabric/styling';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TableRow = _ref => {
  var _passedSettings$isHig, _passedSettings$highl;
  let {
    row,
    style
  } = _ref;
  const passedSettings = row.original.settings;
  const rowSettings = {
    isHighlighted: (_passedSettings$isHig = passedSettings === null || passedSettings === void 0 ? void 0 : passedSettings.isHighlighted) !== null && _passedSettings$isHig !== void 0 ? _passedSettings$isHig : false,
    highlightColor: (_passedSettings$highl = passedSettings === null || passedSettings === void 0 ? void 0 : passedSettings.highlightColor) !== null && _passedSettings$highl !== void 0 ? _passedSettings$highl : getTheme().palette.neutralLighterAlt,
    disableSettings: passedSettings === null || passedSettings === void 0 ? void 0 : passedSettings.disableSettings
  };
  const renderDisabledOverlay = color => {
    return /*#__PURE__*/_jsx("div", {
      style: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 2,
        backgroundColor: color !== null && color !== void 0 ? color : getTheme().palette.white,
        opacity: 0.35
      }
    });
  };
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, row.getRowProps({
    style
  })), {}, {
    className: "tr",
    children: row.cells.map((cell, index) => {
      var _passedSettings$overl, _passedSettings$disab, _passedSettings$disab2, _passedSettings$disab3, _passedSettings$disab4;
      const initZIndex = cell.getCellProps().style.zIndex;
      return /*#__PURE__*/_jsx(Fragment, {
        children: /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, cell.getCellProps()), {}, {
          className: 'td padded',
          style: _objectSpread(_objectSpread({}, cell.getCellProps().style), {}, {
            background: rowSettings.isHighlighted ? rowSettings.highlightColor : getTheme().palette.white,
            zIndex: passedSettings !== null && passedSettings !== void 0 && (_passedSettings$overl = passedSettings.overlayingColumns) !== null && _passedSettings$overl !== void 0 && _passedSettings$overl.includes(cell.column.id) ? 4 : initZIndex
          }),
          children: [(passedSettings === null || passedSettings === void 0 || (_passedSettings$disab = passedSettings.disableSettings) === null || _passedSettings$disab === void 0 ? void 0 : _passedSettings$disab.isDisabled) && renderDisabledOverlay(passedSettings.disableSettings.disabledOverlayColor), /*#__PURE__*/_jsx("div", {
            className: "td__content",
            style: {
              pointerEvents: passedSettings !== null && passedSettings !== void 0 && (_passedSettings$disab2 = passedSettings.disableSettings) !== null && _passedSettings$disab2 !== void 0 && _passedSettings$disab2.isDisabled && !((_passedSettings$disab3 = passedSettings.disableSettings.columnsExcludedFromDisable) !== null && _passedSettings$disab3 !== void 0 && _passedSettings$disab3.includes(cell.column.id)) ? 'none' : undefined,
              zIndex: passedSettings !== null && passedSettings !== void 0 && (_passedSettings$disab4 = passedSettings.disableSettings) !== null && _passedSettings$disab4 !== void 0 && (_passedSettings$disab4 = _passedSettings$disab4.columnsExcludedFromDisable) !== null && _passedSettings$disab4 !== void 0 && _passedSettings$disab4.includes(cell.column.id) ? 3 : undefined
            },
            children: !cell.column.hasCustomCell ? /*#__PURE__*/_jsx("div", {
              className: "td__content--text",
              children: cell.render('Cell')
            }) : cell.render('Cell')
          })]
        }))
      }, index);
    })
  }));
};